import React from 'react';
import { Link } from 'react-router-dom';

const SiteMapSection = ({ section }) => {
  return (
    <div
      className="bg-white flex flex-col rounded-[25px] p-[35px] border-2 border-transparent hover:border-icetex hover:-translate-y-2 transition-all duration-300"
      style={{ boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)' }}
    >
      <div className="flex items-start gap-5 mb-5">
        <div className="flex items-center justify-center flex-shrink-0 w-[60px] h-[60px] bg-blue-50 rounded-[15px] border-2 border-icetex/40">
          <span className="text-icetex w-[30px] h-[30px] flex items-center justify-center">
            {section.icon}
          </span>
        </div>
        <div className="flex-1">
          <h2
            className="text-texto-oscuro font-bold"
            style={{ fontSize: '1.5rem', marginBottom: '8px', lineHeight: '1.3' }}
          >
            {section.title}
          </h2>
          {section.status && (
            <span className="inline-block font-semibold uppercase bg-amber-400 text-white px-3 py-1 rounded-full text-[0.75rem] tracking-[0.5px] ml-[10px]">
              {section.status}
            </span>
          )}
          {section.external && (
            <span className="inline-flex items-center text-icetex font-semibold uppercase bg-blue-50 px-3 py-1 rounded-full text-[0.75rem] tracking-[0.5px] ml-[10px] gap-[5px]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ width: '12px', height: '12px' }}
              >
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                <polyline points="15 3 21 3 21 9"></polyline>
                <line x1="10" y1="14" x2="21" y2="3"></line>
              </svg>
              Externo
            </span>
          )}
        </div>
      </div>

      <p className="text-texto-sec text-[1rem] leading-[1.7] mb-5">
        {section.description}
      </p>

      {section.links && section.links.length > 0 && (
        <div className="bg-fondo-claro p-5 rounded-[15px] mb-[25px] border-l-4 border-icetex">
          <h3 className="text-icetex font-bold uppercase text-[0.95rem] tracking-[0.5px] mb-[15px]">
            Incluye:
          </h3>
          <ul className="list-none p-0 m-0">
            {section.links.map((link, index) => (
              <li
                key={index}
                style={{
                  padding: '10px 0',
                  borderBottom: index < section.links.length - 1 ? '1px solid #e8f0fe' : 'none'
                }}
              >
                {link.external ? (
                  <a
                    href={link.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-texto-oscuro no-underline text-[0.95rem]"
                  >
                    {link.label}
                    <span style={{ marginLeft: '4px' }}>↗</span>
                  </a>
                ) : (
                  <a
                    href={link.path}
                    className="text-texto-oscuro no-underline text-[0.95rem]"
                  >
                    {link.label}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}

      {section.external ? (
        <a
          href={section.path}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-[10px] text-white font-bold uppercase no-underline py-[14px] px-[30px] rounded-full text-[0.95rem] tracking-[0.5px] mt-auto bg-gradient-to-br from-icetex to-icetex-dark hover:-translate-y-0.5 transition-all duration-300 border-0"
          style={{ boxShadow: '0 4px 15px rgba(0, 63, 129, 0.3)' }}
        >
          Visitar
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ width: '18px', height: '18px' }}
          >
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </a>
      ) : section.status ? (
        <div className="inline-flex items-center justify-center gap-[10px] font-bold uppercase py-[14px] px-[30px] bg-gray-200 text-gray-500 rounded-full text-[0.95rem] tracking-[0.5px] cursor-not-allowed mt-auto">
          Próximamente
        </div>
      ) : (
        <Link
          to={section.path}
          className="inline-flex items-center justify-center gap-[10px] text-white font-bold uppercase no-underline py-[14px] px-[30px] rounded-full text-[0.95rem] tracking-[0.5px] mt-auto bg-gradient-to-br from-icetex to-icetex-dark hover:-translate-y-0.5 transition-all duration-300"
          style={{ boxShadow: '0 4px 15px rgba(0, 63, 129, 0.3)' }}
        >
          Ir a la sección
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ width: '18px', height: '18px' }}
          >
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </Link>
      )}
    </div>
  );
};

export default SiteMapSection;
